import axios from 'axios';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { APPLICATION_API_BASE_URL } from '../configuration/config';

const axiosInstance = axios.create({
  baseURL: APPLICATION_API_BASE_URL
});

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      const refreshToken = Cookies.get('refreshToken');
      if (refreshToken) {
        try {
          // Call your newToken endpoint
          const refreshResponse = await axios.post(`${APPLICATION_API_BASE_URL}/auth/newToken`, {
            refresh_token: refreshToken
          });
          const newToken = refreshResponse.data.data.id_token;
          const newRefreshToken = refreshResponse.data?.data?.refresh_token;
          Cookies.set('token', newToken);
          if (newRefreshToken) {
            Cookies.set('refreshToken', newRefreshToken);
          }
          // Update the original request with the new token and retry
          error.config.headers['authorization'] = `${newToken}`;
          return axiosInstance(error.config);
        } catch (refreshError) {
          // Refresh failed, log out
          toast.error('Session expired. Please login again.');
          Object.keys(Cookies.get()).forEach((cookie) => {
            Cookies.remove(cookie);
          });
          window.location.replace('/');
        }
      } else {
        toast.error('Session expired. Please login again.');
        Object.keys(Cookies.get()).forEach((cookie) => {
          Cookies.remove(cookie);
        });
        window.location.replace('/');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
